import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AudienceTagsDialogComponent } from 'src/app/components/dialogs/audiences/audience-tags-dialog/audience-tags-dialog.component';
import { Audience } from 'src/app/models/services/audience';

// Based on: https://darchuk.net/2019/01/11/angular-making-a-modal-service-by-extending-ngbmodal/
@Injectable({
  providedIn: 'root'
})
export class AudienceTagsDialogService {
  lastErrorCloseResult: string;

  constructor(private modalService: NgbModal) { }

  public show = (audience: Audience, acceptCallback: () => void, rejectCallback?: () => void): void => {    
    var ref = this.modalService.open(AudienceTagsDialogComponent, { size: 'l' });

    // Get the OkDialog from the NgbModal object  
    let dialog: AudienceTagsDialogComponent = ref.componentInstance as AudienceTagsDialogComponent;

    // Set the dialog's properties
    dialog.audience = audience;
    dialog.accept = () => {
      ref.close(1); 
    };

    dialog.dismiss = () => {
      ref.dismiss(2);
    };

    ref.result.then((result) => {
      switch (result) {
        case 1:
          acceptCallback();
          break;
        default:
          if (rejectCallback)
            rejectCallback();
      }
    }, (reason) => {
      if (rejectCallback)
        rejectCallback();
    })
  }
}
